import React from 'react';
import { TrendingUp, CreditCard, Calendar, DollarSign } from 'lucide-react';

const StockParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  dividendFrequencyTypes,
  currencyTypes
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Цена акции */}
      <div>
        <label htmlFor="stockPrice" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <TrendingUp className="w-4 h-4 mr-2 text-green-500" />
          Цена акции
        </label>
        <div className="flex">
          <input
            type="text"
            id="stockPrice"
            name="stockPrice"
            value={formData.stockPrice}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.stockPrice ? 'input-error' : ''}`}
            placeholder="Введите цену"
          />
          <select
            name="currency"
            value={formData.currency}
            onChange={handleInputChange}
            className="form-select ml-2 w-1/4"
          >
            {currencyTypes.map((currency) => (
              <option key={currency.id} value={currency.id}>
                {currency.symbol}
              </option>
            ))}
          </select>
        </div>
        {errors.stockPrice && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.stockPrice}
          </p>
        )}
      </div>

      {/* Количество акций */}
      <div>
        <label htmlFor="sharesCount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <CreditCard className="w-4 h-4 mr-2 text-green-500" />
          Количество акций
        </label>
        <input
          type="text"
          id="sharesCount"
          name="sharesCount"
          value={formData.sharesCount}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.sharesCount ? 'input-error' : ''}`}
          placeholder="Введите количество"
        />
        {errors.sharesCount && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.sharesCount}
          </p>
        )}
      </div>

      {/* Дивиденд на акцию */}
      <div>
        <label htmlFor="dividendPerShare" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <DollarSign className="w-4 h-4 mr-2 text-green-500" />
          Дивиденд на акцию
        </label>
        <input
          type="text"
          id="dividendPerShare"
          name="dividendPerShare"
          value={formData.dividendPerShare}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.dividendPerShare ? 'input-error' : ''}`}
          placeholder="Введите дивиденд"
        />
        {errors.dividendPerShare && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.dividendPerShare}
          </p>
        )}
      </div>

      {/* Периодичность выплат */}
      <div>
        <label htmlFor="dividendFrequency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Периодичность выплат
        </label>
        <select
          id="dividendFrequency"
          name="dividendFrequency"
          value={formData.dividendFrequency}
          onChange={handleInputChange}
          className="form-select w-full"
        >
          {dividendFrequencyTypes.map((frequency) => (
            <option key={frequency.id} value={frequency.id}>
              {frequency.name}
            </option>
          ))}
        </select>
      </div>

      {/* Дата начала инвестирования */}
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-green-500" />
          Дата начала инвестирования
        </label>
        <input
          type="date"
          id="startDate"
          name="startDate"
          value={formData.startDate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.startDate ? 'input-error' : ''}`}
        />
        {errors.startDate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.startDate}
          </p>
        )}
      </div>

      {/* Валюта калькулятора */}
      <div>
        <label htmlFor="currency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Валюта расчета
        </label>
        <select
          id="currency"
          name="currency"
          value={formData.currency}
          onChange={handleInputChange}
          className="form-select w-full"
        >
          {currencyTypes.map((currency) => (
            <option key={currency.id} value={currency.id}>
              {currency.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default StockParametersSection;